"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegistryKey = void 0;
var RegistryKey;
(function (RegistryKey) {
    RegistryKey["Controller"] = "controller";
    RegistryKey["Guardian"] = "guardian";
    RegistryKey["Keeper"] = "keeper";
    RegistryKey["BadgerTree"] = "badgerTree";
    RegistryKey["Governance"] = "governance";
    RegistryKey["DevGovernance"] = "devGovernance";
    RegistryKey["ProxyAdminDev"] = "proxyAdminDev";
    RegistryKey["ProxyAdminTimelock"] = "proxyAdminTimelock";
    RegistryKey["GovernanceTimelock"] = "governanceTimelock";
    RegistryKey["Timelock"] = "timelock";
    RegistryKey["KeeperAccessControl"] = "keeperAccessControl";
    RegistryKey["RewardsLogger"] = "rewardsLogger";
    RegistryKey["Badger"] = "BADGER";
    RegistryKey["ibBTC"] = "ibBTC";
})(RegistryKey = exports.RegistryKey || (exports.RegistryKey = {}));
//# sourceMappingURL=registry-key.enum.js.map